import React from 'react';
import wordmark from './logo-vikarexperten.png';

/**
 * Logo — the Vikar Experten lockup (green sprout mark + white wordmark).
 *
 * CHANGED in 1.17.0-dev.1. Previously this drew a placeholder SVG: a blue
 * (#0055A4) rounded square with a white clock. That was never the company mark.
 *
 * IMPORTANT: the wordmark is WHITE. It only works on brand red or on ink — that
 * is why the sidebar header and the auth header are now red plates. There is no
 * dark or single-colour version of the wordmark in the brand assets, so do not
 * place this on a white surface; if you need that, ask marketing for a vector
 * master. `assets/logo-mark.png` (the sprout alone, transparent) is the safe
 * choice on any background.
 *
 * Renders an <img>, not an <svg>, because the source asset is a raster lockup.
 * CSS that sized the old icon via `svg { ... }` has been updated to `img, svg`.
 */
const Logo = ({ height = 40, alt = 'Vikar Experten', style, ...props }) => (
  <img
    src={wordmark}
    alt={alt}
    style={{ height, width: 'auto', display: 'block', ...style }}
    {...props}
  />
);

export default Logo;
